var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page", attrs: { id: "contactDebtorList" } },
    [
      _c(
        "f7-toolbar",
        { staticClass: "contactListToolbar" },
        [
          _c(
            "f7-link",
            {
              staticClass:
                "streammindContactListButton yellowButton okButtonContactList",
              on: { click: _vm.goBack },
            },
            [_vm._v("OK")]
          ),
          _vm._v(" "),
          _c(
            "f7-link",
            {
              staticClass: "streammindContactListButton yellowButton",
              on: { click: _vm.cancel },
            },
            [_vm._v("Cancel")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-content" },
        [
          _c(
            "div",
            { staticClass: "contactDebtorListButtonContainer" },
            [
              _c(
                "f7-grid",
                { attrs: { "no-gutter": "" } },
                [
                  _c(
                    "f7-col",
                    {
                      staticClass: "pilotageTabController",
                      attrs: { width: "50" },
                    },
                    [
                      _c(
                        "f7-link",
                        {
                          staticClass: "pilotageLink",
                          class: { tabActive: _vm.currentRole === "simple" },
                          attrs: {
                            "tab-link": ".requestContactTab1",
                            active: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeCurrentRole("simple")
                            },
                          },
                        },
                        [_vm._v("Contact List")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "f7-col",
                    {
                      staticClass: "pilotageTabController",
                      attrs: { width: "50" },
                    },
                    [
                      _c(
                        "f7-link",
                        {
                          staticClass: "pilotageLink",
                          class: { tabActive: _vm.currentRole === "group" },
                          attrs: { "tab-link": ".requestContactTab2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeCurrentRole("group")
                            },
                          },
                        },
                        [_vm._v("Group List")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "f7-tabs",
            [
              _c("f7-searchbar", {
                attrs: {
                  "cancel-link": "Cancel",
                  "search-list": "#remind-settings-contacts-list",
                  placeholder: "Search in Contacts",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c(
                    "f7-tab",
                    {
                      staticClass: "requestContactTab1",
                      attrs: { active: "" },
                    },
                    [
                      _c(
                        "f7-list",
                        {
                          attrs: {
                            id: "remind-settings-contacts-list",
                            contacts: "",
                          },
                        },
                        _vm._l(this.contacts, function (group, key) {
                          return _c(
                            "f7-list-group",
                            { key: key },
                            [
                              _c("f7-list-item", {
                                attrs: { title: key, "group-title": "" },
                              }),
                              _vm._v(" "),
                              _vm._l(group, function (contact) {
                                return _c(
                                  "li",
                                  {
                                    on: {
                                      change: function ($event) {
                                        return _vm.changeItem()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "label-checkbox item-content",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.contactsSelected,
                                              expression: "contactsSelected",
                                            },
                                          ],
                                          staticClass: "inputContact",
                                          attrs: {
                                            type: "checkbox",
                                            name: "remindSettingsContactsCheckbox",
                                          },
                                          domProps: {
                                            value: contact.id,
                                            checked: Array.isArray(
                                              _vm.contactsSelected
                                            )
                                              ? _vm._i(
                                                  _vm.contactsSelected,
                                                  contact.id
                                                ) > -1
                                              : _vm.contactsSelected,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.contactsSelected,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = contact.id,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.contactsSelected =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.contactsSelected = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.contactsSelected = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "item-media" },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "icon icon-form-checkbox",
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "item-inner" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "item-title" },
                                              [_vm._v(_vm._s(contact.label))]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "f7-tab",
                    { staticClass: "requestContactTab2" },
                    [
                      _c("f7-searchbar", {
                        attrs: {
                          "cancel-link": "Cancel",
                          "search-list": "#remind-settings-contact-groups-list",
                          placeholder: "Search in Groups",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "f7-list",
                        {
                          attrs: { id: "remind-settings-contact-groups-list" },
                        },
                        _vm._l(
                          _vm.contactGroups,
                          function (contactGroup, index) {
                            return _c(
                              "li",
                              {
                                on: {
                                  change: function ($event) {
                                    return _vm.changeGroupItem()
                                  },
                                },
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass: "label-checkbox item-content",
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.contactGroupsSelected,
                                          expression: "contactGroupsSelected",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        name: "remindSettingsContactGroupsCheckbox",
                                      },
                                      domProps: {
                                        value: contactGroup.id,
                                        checked: Array.isArray(
                                          _vm.contactGroupsSelected
                                        )
                                          ? _vm._i(
                                              _vm.contactGroupsSelected,
                                              contactGroup.id
                                            ) > -1
                                          : _vm.contactGroupsSelected,
                                      },
                                      on: {
                                        change: function ($event) {
                                          var $$a = _vm.contactGroupsSelected,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = contactGroup.id,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.contactGroupsSelected =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.contactGroupsSelected = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.contactGroupsSelected = $$c
                                          }
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "item-media" }, [
                                      _c("i", {
                                        staticClass: "icon icon-form-checkbox",
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "item-inner" }, [
                                      _c("div", { staticClass: "item-title" }, [
                                        _vm._v(_vm._s(contactGroup.label)),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "layoutBottomContactList" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }